import type { ChangeEventHandler, FocusEventHandler, Ref } from 'react';
import styles from './toggle-field.module.css';

/**
 * `checked` is required on purpose. React switches an input from uncontrolled to controlled the
 * moment it first receives a string after an undefined, which costs the caret its position and
 * writes a warning to the console - and that is exactly what an edit form does when it resets
 * itself once the record has loaded. Wire this up through Controller, not register().
 */
type ToggleFieldProps = {
  label: string;
  name: string;
  checked: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  ref?: Ref<HTMLInputElement>;
  description?: string;
  disabled?: boolean;
};

export const ToggleField = ({
  label,
  name,
  checked,
  onChange,
  onBlur,
  ref,
  description,
  disabled = false,
}: ToggleFieldProps) => (
  <label className={styles.field}>
    <span className={styles.text}>
      <span className={styles.label}>{label}</span>
      {description !== undefined && <span className={styles.description}>{description}</span>}
    </span>
    <input
      ref={ref}
      className={styles.input}
      type="checkbox"
      role="switch"
      name={name}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      onBlur={onBlur}
    />
    <span className={styles.track} aria-hidden="true">
      <span className={styles.thumb} />
    </span>
  </label>
);
